import { Calendar } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Select, SelectOption } from '@/components/ui/select'

interface DateRangeOption {
  label: string
  value: string
  start_date: string
  end_date: string
}

interface ShoppingListDateRangePickerProps {
  dateRangeOptions: DateRangeOption[]
  selectedDateRange: DateRangeOption | null
  useCustomRange: boolean
  customDateRange: { start: string; end: string }
  onSelectedDateRangeChange: (option: DateRangeOption | null) => void
  onUseCustomRangeChange: (value: boolean) => void
  onCustomDateRangeChange: (nextRange: { start: string; end: string }) => void
}

export function ShoppingListDateRangePicker({
  dateRangeOptions,
  selectedDateRange,
  useCustomRange,
  customDateRange,
  onSelectedDateRangeChange,
  onUseCustomRangeChange,
  onCustomDateRangeChange,
}: ShoppingListDateRangePickerProps) {
  return (
    <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_220px]">
      <div className="grid gap-4 md:grid-cols-2">
        <label className="space-y-2">
          <span className="text-sm font-medium text-gray-700">Periode</span>
          <Select
            value={selectedDateRange?.value ?? ''}
            onChange={(event) => {
              const option = dateRangeOptions.find((currentOption) => currentOption.value === event.target.value)
              onSelectedDateRangeChange(option ?? null)
              onUseCustomRangeChange(false)
            }}
          >
            <SelectOption value="">Selecteer periode...</SelectOption>
            {dateRangeOptions.map((option) => (
              <SelectOption key={option.value} value={option.value}>
                {option.label}
              </SelectOption>
            ))}
          </Select>
        </label>

        <div className="space-y-2">
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
            <input
              type="checkbox"
              checked={useCustomRange}
              onChange={(event) => onUseCustomRangeChange(event.target.checked)}
            />
            Aangepaste periode
          </label>
          <div className="grid grid-cols-2 gap-2">
            <Input
              type="date"
              value={customDateRange.start}
              onChange={(event) =>
                onCustomDateRangeChange({
                  ...customDateRange,
                  start: event.target.value,
                })
              }
              disabled={!useCustomRange}
            />
            <Input
              type="date"
              value={customDateRange.end}
              onChange={(event) =>
                onCustomDateRangeChange({
                  ...customDateRange,
                  end: event.target.value,
                })
              }
              disabled={!useCustomRange}
            />
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
        <div className="font-medium text-gray-900">Wat gebeurt er?</div>
        <p className="mt-2">We bundelen alle ingrediënten uit je geplande diners en maken daar één boodschappenlijst van.</p>
        {(useCustomRange ? customDateRange.start && customDateRange.end : selectedDateRange) && (
          <div className="mt-3 flex items-center gap-2 text-xs text-gray-500">
            <Calendar className="h-3.5 w-3.5" />
            {useCustomRange
              ? `${customDateRange.start} t/m ${customDateRange.end}`
              : `${selectedDateRange?.start_date} t/m ${selectedDateRange?.end_date}`}
          </div>
        )}
      </div>
    </div>
  )
}
